module.exports = __webpack_public_path__ + "static/media/animation.8b7541da.gif";